import React, { useState, useEffect, useContext } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';

import Navbar from './components/Navbar/Navbar';
import Controle from './components/Controle/Controle';
import SinglePageContainer from './components/PageContainers/SinglePageContainer';
import DoublePageContainer from './components/PageContainers/DoublePageContainer';
import LoginPage from './components/Login/LoginPage';
import SetPasswordPage from './components/SetPassword/SetPasswordPage';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import ShipmentForm from './components/ShipmentForm/ShipmentForm';
import GenericTableParamSetter from './components/GenericTable/GenericTableParamSetter';
import ClientForm from './components/ClientForm/ClientForm';
import CarrierForm from './components/CarrierForm/CarrierForm';
import StatsLayout from './components/StatsLayout/StatsLayout';
import { UserContext } from './components/UserContext/UserContext';
import BaseForm from './components/BaseForm/FormContext';
import ReconnectModal from './components/ReconnectModal/ReconnectModal';
import PDFViewer from './components/PDFViewer/PDFViewer';

function App() {
  const [showNavbar, setShowNavbar] = useState(true);
  const [showTabsFooter, setShowTabsFooter] = useState(true);
  const [showReconnectModal, setShowReconnectModal] = useState(false);
  const { logout } = useContext(UserContext);

  const handleReconnect = () => {
    setShowReconnectModal(false);
    window.dispatchEvent(new CustomEvent('reconnect-success'));
  };

  const handleLogoutFromModal = () => {
    setShowReconnectModal(false);
    window.dispatchEvent(new CustomEvent('reconnect-logout'));
    logout();
  };

  useEffect(() => {
    const handleLogout = () => {
      logout();
    };

    const handleSessionExpired = () => {
      setShowReconnectModal(true);
    };

    window.addEventListener('logout-event', handleLogout);
    window.addEventListener('session-expired', handleSessionExpired);

    return () => {
      window.removeEventListener('logout-event', handleLogout);
      window.removeEventListener('session-expired', handleSessionExpired);
    };
  }, [logout]);

  return (
    <div className="App">
      <PDFViewer />
      {showReconnectModal && (
        <ReconnectModal onReconnect={handleReconnect} onLogout={handleLogoutFromModal} />
      )}
      <Router>
        {showNavbar && (
          <div className="navbarContainer">
            <Navbar />
          </div>
        )}
        <div className={`pageContainer ${showNavbar ? '' : 'navbar-hidden'}`}>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/set-password" element={<SetPasswordPage />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <SinglePageContainer />
                </PrivateRoute>
              }
            >
              <Route index element={<Controle />} />
            </Route>
            <Route
              path="/dossiers"
              element={
                <PrivateRoute>
                  <DoublePageContainer data_type={'shipment'} showTabsFooter={showTabsFooter} />
                </PrivateRoute>
              }
            >
              <Route
                index
                element={<GenericTableParamSetter data_type={'shipment'} layout={'shipment'} />}
              />
              <Route
                path=":shipment_number"
                element={
                  <BaseForm data_type={'shipment'}>
                    <ShipmentForm
                      setShowNavbar={setShowNavbar}
                      setShowTabsFooter={setShowTabsFooter}
                    />
                  </BaseForm>
                }
              />
            </Route>
            <Route
              path="/pre-fac"
              element={
                <PrivateRoute>
                  <DoublePageContainer data_type={'shipment'} showTabsFooter={showTabsFooter} />
                </PrivateRoute>
              }
            >
              <Route
                index
                element={<GenericTableParamSetter data_type={'shipment'} layout={'pre-fac'} />}
              />
              <Route
                path=":shipment_number"
                element={
                  <BaseForm data_type={'shipment'}>
                    <ShipmentForm
                      setShowNavbar={setShowNavbar}
                      setShowTabsFooter={setShowTabsFooter}
                    />
                  </BaseForm>
                }
              />
            </Route>
            <Route
              path="/supprimes"
              element={
                <PrivateRoute>
                  <DoublePageContainer data_type={'shipment'} showTabsFooter={showTabsFooter} />
                </PrivateRoute>
              }
            >
              <Route
                index
                element={<GenericTableParamSetter data_type={'shipment'} layout={'deleted'} />}
              />
              <Route
                path=":shipment_number"
                element={
                  <BaseForm data_type={'shipment'}>
                    <ShipmentForm
                      setShowNavbar={setShowNavbar}
                      setShowTabsFooter={setShowTabsFooter}
                    />
                  </BaseForm>
                }
              />
            </Route>
            <Route
              path="/factures"
              element={
                <PrivateRoute>
                  <DoublePageContainer data_type={'invoice'} showTabsFooter={showTabsFooter} />
                </PrivateRoute>
              }
            >
              <Route
                index
                element={<GenericTableParamSetter data_type={'invoice'} layout={'invoice'} />}
              />
            </Route>
            <Route
              path="/facturation-tps"
              element={
                <PrivateRoute>
                  <DoublePageContainer data_type={'shipment'} showTabsFooter={showTabsFooter} />
                </PrivateRoute>
              }
            >
              <Route
                index
                element={
                  <GenericTableParamSetter data_type={'shipment'} layout={'carrier-billing'} />
                }
              />
              <Route
                path=":shipment_number"
                element={
                  <BaseForm data_type={'shipment'}>
                    <ShipmentForm
                      setShowNavbar={setShowNavbar}
                      setShowTabsFooter={setShowTabsFooter}
                    />
                  </BaseForm>
                }
              />
            </Route>
            <Route
              path="/clients"
              element={
                <PrivateRoute>
                  <DoublePageContainer data_type={'client'} showTabsFooter={showTabsFooter} />
                </PrivateRoute>
              }
            >
              <Route
                index
                element={<GenericTableParamSetter data_type={'client'} layout={'client'} />}
              />
              <Route
                path=":client_code"
                element={
                  <BaseForm data_type={'client'}>
                    <ClientForm />
                  </BaseForm>
                }
              />
            </Route>
            <Route
              path="/transporteurs"
              element={
                <PrivateRoute>
                  <DoublePageContainer data_type={'carrier'} showTabsFooter={showTabsFooter} />
                </PrivateRoute>
              }
            >
              <Route
                index
                element={<GenericTableParamSetter data_type={'carrier'} layout={'carrier'} />}
              />
              <Route
                path=":carrier_code"
                element={
                  <BaseForm data_type={'carrier'}>
                    <CarrierForm />
                  </BaseForm>
                }
              />
            </Route>
            <Route
              path="/stats"
              element={
                <PrivateRoute>
                  <DoublePageContainer data_type={'stats'} showTabsFooter={showTabsFooter} />
                </PrivateRoute>
              }
            >
              <Route path="ca-marge">
                <Route index element={<StatsLayout displayed_report={'sales_margin'} />} />
              </Route>
              <Route path="nb-dossiers">
                <Route index element={<StatsLayout displayed_report={'number_of_shipments'} />} />
              </Route>
              <Route path="clients">
                <Route index element={<StatsLayout displayed_report={'clients'} />} />
              </Route>
              <Route path="litiges">
                <Route index element={<StatsLayout displayed_report={'litiges'} />} />
              </Route>
            </Route>
          </Routes>
        </div>
      </Router>
    </div>
  );
}

export default App;
